/**
 * Helpers de formatage pour les plages numériques (surface, budget).
 *
 * ⚠️  DÉPRÉCIÉ — Conservé pour back-compatibilité.
 * Les nouveaux composants doivent importer directement depuis `./formatFR`
 * (formatSurfaceRangeFR, formatBudgetRangeFR, etc.).
 */

import { formatSurfaceRangeFR, formatBudgetRangeFR } from './formatFR';

/** @deprecated use formatSurfaceRangeFR from ./formatFR */
export const formatSurfaceRange = formatSurfaceRangeFR;

/** @deprecated use formatBudgetRangeFR from ./formatFR */
export const formatBudgetRange = formatBudgetRangeFR;
